<template>
<div>
	<!-- Toolbar -->
	<Toolbar />
	<!-- breadcrumb -->
	<Breadcrumbs v-if='!loading'/>

	<v-container v-if='!loading'>
	<!-- <v-row  style="background: #FAFAFA" v-if='!loading'> -->
	<v-row  style="background: #FAFAFA">
		
	<!-- datatable categorias -->
	<v-container fluid fill-height style="background: #EEEEEE" class="align-content-start" v-if="$store.state.categoryModule.showDatatable">
		<v-container v-if="!$store.state.show">
			<v-row justify="center">
				<v-col cols="12" sm="10">
					<v-data-table
						:headers="headers"
						:items="cates"
						:items-per-page=15
					
						item.key='cates.id'
						no-data-text="No hay categorias aún ..."
					>
						<!-- slot Top table -->
						<template v-slot:top>
							<v-toolbar flat color="white">
								<v-toolbar-title v-html="`Categorias ( ${business.name} )`"/>
								<v-divider class="mx-4" inset vertical></v-divider>
								<v-spacer />
								<v-col align="right" justify="center" class="my-3">
									<v-btn class="mt-2" fab dark color="secondary" @click="newCategory">
										<v-icon dark>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<!-- <cat-dialog /> -->
							</v-toolbar>
						</template>
						<!-- Order -->
						<template v-slot:item.order="{ item }">
								<v-layout justify-center align-center>
									<v-icon @click="toggleOrder(item,'up')" size="32" color="grey darken-1">mdi-menu-up</v-icon>
									{{item.order}}
									<v-icon @click="toggleOrder(item,'down')" size="32" color="grey darken-1">mdi-menu-down</v-icon>
								</v-layout>
						</template>
						<!-- Status -->
						<template v-slot:item.visible="{ item }">
								<v-layout justify-center>
							<v-switch
								color="success"
								v-model="item.visible"
								@change="toogleVisible(item)"
							></v-switch>
								</v-layout>
						</template>
						<!-- columna accion -->
						<template v-slot:item.action="{ item }">
							<v-icon  class="botones_list" color="primary"  @click="editCategory(item)">
								mdi-file-edit
							</v-icon>
							<v-icon class="botones_list" color="primary" @click="itemsCat(item)">
								mdi-view-list
							</v-icon>
							<v-icon class="botones_list"
								@click="removeCategory(item, cates.map(function(x) {return x.id; }).indexOf(item.id))"
								color="secondary"
							>
								mdi-delete
							</v-icon>
						</template>


					</v-data-table>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
	<items  
		:business_id="$store.state.businessModule.business.id" 
		:category_id="$store.state.categoryModule.category.id"
		:category_fullname="category_fullname"
		v-if="$store.state.itemModule.showComponent" 
	/>
	
	<!-- bloque despliegue para editar negocio y cliente -->
	<!-- <v-container fluid fill-height style="background: white" class="align-content-start" v-if="!$store.state.categoryModule.showDatatable">
		<businessDialog v-if="$store.state.businessModule.showComponent" />
		<customerDialog v-if="$store.state.customerModule.showComponent" />
	</v-container> -->

	<!-- Dialog de Category -->
	<v-dialog v-model="openDialog" persistent max-width="600">
				<v-card>
					<v-card-title class="headline">{{ categoryDialogEditMode ? 'EDITAR' : 'CREAR'}} CATEGORIA</v-card-title>
						<v-card-text>
							<v-form v-model="formValidity">
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field
												color="accent"
												v-model="categoryForEdit.name"
												label="Titulo"
												prepend-inner-icon="mdi-view-agenda"
												dense
												filled />
										<v-text-field
												color="accent"
												v-model="categoryForEdit.subtitle"
												label="Subtitulo"
												prepend-inner-icon="mdi-view-agenda-outline"
												dense
												filled />
										<v-switch
												inset class="ma-2"
												color="success"
												v-model="categoryForEdit.visible"
												:label="`Visible: ${categoryForEdit.visible ? 'SI' : 'NO'}`" />
									</v-col>
									<v-col cols="12" md="6">
										<v-card>
											<image-uploader
													ref="imager"
													:maxWidth="600"
													:quality="0.7"
													:preview="true"
													:className="['fileinput', { 'fileinput--loaded': hasImage }]"
													:capture="false"
													:debug="1"
													doNotResize="gif"
													:autoRotate="true"
													outputFormat="verbose"
													@input="setImage"
												>
											
												<label for="fileInput" slot="upload-label">
													<v-img 
														v-if="showImage"
														:src="(photoExist) ? categoryForEdit.photo_url : photo.dataUrl"
														aspect-ratio="1.778"
													/>
													<span class="upload-caption"> <v-icon >mdi-camera</v-icon> {{
														hasImage ? "Click Reemplazar" : "Click para subir"
													}}</span>
												</label>
											</image-uploader>
										</v-card>	

									</v-col>
								</v-row>
							</v-form>
						
						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn :loading="saving" class="white--text" color="accent" @click="updateCategory" v-if="categoryDialogEditMode">ACTUALIZAR CATEGORIA</v-btn>
							<v-btn :loading="saving" class="white--text" color="accent" @click="addCategory" v-else>CREAR CATEGORIA</v-btn>
							<v-btn outlined color="secondary" @click="close">CANCELAR</v-btn>
						</v-card-actions>
				</v-card>
		</v-dialog>
	</v-row>
	<!-- <Notification /> -->
	<v-snackbar
		top
		right
		:timeout="alert.timeout"
		:color="alert.color"
		v-model="alert.show">
			{{ alert.message }}
	</v-snackbar>
	</v-container>
	<v-container v-if='loading' fill-height>
		<v-layout flex align-center justify-center>
			<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
		</v-layout>
	</v-container>
</div>
</template>

<script>
	import {mapState, mapActions, mapGetters } from 'vuex';
	var firebase = require("firebase/app")
	import { db, storage } from '@/main';
	export default {
		components: {
			Toolbar: () => import('@/components/customer/Toolbar.vue'),
			Breadcrumbs: () => import('@/components/customer/Breadcrumbs.vue'),
			Items: () => import('@/components/customer/Items.vue'),
		},

		created(){

			this.loading = true;
			if (this.$store.state.authModule.logged && this.$store.state.userModule.user.id == null ){
				this.getCurrentUserAndBusiness();
			} else {
				this.$store.commit('SET_SHOW', false, {root: true}) //activa categorias oculta items
				this.getCurrentBusiness();
			}

			this.$store.commit('categoryModule/SET_SHOW_DATATABLE', true, {root: true})
			this.$store.commit('categoryModule/SET_SHOW_BTN_TOOLBAR', false, {root: false})
			this.$store.commit('businessModule/SET_SHOW_COMPONENT', false, {root: false})
			this.$store.commit('customerModule/SET_SHOW_COMPONENT', false, {root: true})

		},
		data() {
				return {
					hasImage: false,
					openCates: true,
					openDialog: false,
					loading: false,
					cates: [],
					saving: false,
					noImage: '/static/images/not-logo.jpg',
					headers: [
						{text: 'Titulo', value: 'name', align: 'left'},
						{text: 'Subtitulo', value: 'subtitle', align: 'left'},
						{text: 'Orden', value: 'order', align: 'center'},
						{text: 'Visible', value: 'visible', align: 'center'},
						{text: '', value: 'action', sortable: false,align: 'end', },
					],
					category_id: '',
					category_fullname: '',

					catDialog: false,
					photo: {
						dataUrl: '/img/static/not-logo.jpg'
					},
					uploaded: false,
					formValidity: false,
					textRules: [v => !!v || "Este dato es requerido"],

				}
		},
		methods: {
			...mapActions('authModule',['logOut']),
			...mapActions('businessModule', ['getbusinesses','toggleBusinessDialog','setBusiness']),
			...mapActions('customerModule', ['toggleCustomerDialog']),
			setImage: function(output) {
				this.hasImage = true;
				this.photo = output;
				this.uploaded = true;
				this.categoryForEdit.photo_url = null
			},
			
			async getCurrentUserAndBusiness(){
				try {
					await this.$store.dispatch('userModule/getUser',this.$store.state.authModule.user.uid, {root: true});
					this.getCurrentBusiness();
				} catch (e) {
					console.log(e)
				} finally {
					this.loading = false;
				}

			},

			async getCurrentBusiness(){
				await db.collection('bussiness').where('customer_id', '==', this.$store.state.userModule.user.id).limit(1).get()
					.then(snap =>{
						snap.forEach(doc =>{
							this.$store.commit('businessModule/SET_BUSINESS', doc.data(),{root: true})
						});
						this.getCategories( this.$store.state.businessModule.business.id )
						this.loading = false;
					})
			},
			

			async getCategories(){
				let cats = []
				try {
					await db.collection('bussiness').doc(this.$store.state.businessModule.business.id).collection('categories')
						.orderBy('order').onSnapshot(snap => {
							cats = []
							snap.forEach(doc => {
								cats.push({ id: doc.id, ...doc.data() })
							})
							this.cates = cats;
							this.$store.commit('categoryModule/SET_CATEGORIES', this.cates, {root: true})
					});					
				} catch (error) {
					console.log(error)
				} finally {
					this.loading = false
				}

			},
	
			toogleVisible(item){
				db.collection('bussiness').doc(this.business.id).collection('categories').doc(item.id).update({ visible: item.visible });
			},
			toggleOrder(item,to){
				if ( to == 'down' && item.order < this.cates.length){
					const nextItem = this.cates.find(e => e.order === item.order+1 )
					db.collection('bussiness').doc(this.currentBusiness.id).collection('categories').doc(item.id).update({ order: item.order+1 });
					db.collection('bussiness').doc(this.currentBusiness.id).collection('categories').doc(nextItem.id).update({ order: item.order });
				} else if (to == 'up' && item.order > 1) {
					const nextItem = this.cates.find(e => e.order === item.order-1 )
					db.collection('bussiness').doc(this.currentBusiness.id).collection('categories').doc(item.id).update({ order: item.order-1 });
					db.collection('bussiness').doc(this.currentBusiness.id).collection('categories').doc(nextItem.id).update({ order: item.order });
				}
			},
			newCategory(){
				const cat = {id: '',name: '',order: 1,photo_name: '',photo_url: '',subtitle: '',visible: true	}
				this.$store.commit('categoryModule/SET_CATEGORY', cat, {root: true})
				this.$store.commit('categoryModule/SET_EDIT_MODE', false, {root: true})
				this.openDialog = true;
			},
			editCategory(category){
				this.$store.commit('categoryModule/SET_CATEGORY', category, {root: true})
				this.$store.commit('categoryModule/SET_EDIT_MODE', true, {root: true})
				this.openDialog = true;
			},
			itemsCat(item){
				const subtitle = (item.category_subtitle != null ) ? item.category_subtitle : ''
				this.category_fullname = `${item.name} ${subtitle}`
				this.category_id = item.id

				this.$store.commit('categoryModule/SET_CATEGORY', item, {root: true})
				this.$store.commit('categoryModule/SET_SHOW_BTN_TOOLBAR', true, {root: false})
				this.$store.commit('categoryModule/SET_SHOW_DATATABLE', false, {root: false})
				this.$store.commit('itemModule/SET_SHOW_COMPONENT', true, {root: true})

			},
			async removeCategory(category, index){
				let res = await this.$confirm('Borrará una CATEGORÍA con sus ITEMS. Operación no tiene reverso',
						{
							title: "CUIDADO",
							buttonTrueText: "Aceptar",
							buttonFalseText: "Cancelar",
							color: "red",
							icon: "mdi-hand-right",
							width: 350,
							property: "$confirm",
						})

					if (res) {
						let batch = db.batch()
						this.cates.splice(index,1)
						// borrar todos los items de la categoria
						db.collection('bussiness').doc(this.business.id)
						.collection('items').where('category_id','==',category.id).get()
						.then(snapshot => {
							snapshot.docs.forEach(doc => {
								batch.delete(doc.ref);
							});
							return batch.commit();
						})
						// borrar la categoria
						db.collection('bussiness').doc(this.business.id)
							.collection('categories').doc(category.id).delete();

						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,
							color: 'error',
							message: 'Categoria y sus Items eliminados satisfactoriamente',
							timeout: 1000
						});	
					}

			},


			async addCategory(){
				this.saving = true
				this.categoryForEdit.id = Math.floor(Date.now() / 1000).toString();
				const business_id = this.currentBusiness.id;
				let next = 0;
				await db.collection('bussiness').doc(business_id).collection('categories').get()
					.then( (snap) => {
						next = snap.size+1
					})
				this.categoryForEdit.order = next	

				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`categories/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.categoryForEdit.photo_url = await refPhoto.getDownloadURL()
					this.categoryForEdit.photo_name = fileNamePhoto
					this.photo = null
				}

				db.collection('bussiness').doc(business_id).collection('categories').doc(this.categoryForEdit.id)
					.set( this.categoryForEdit )
					.then( docRef => {
						this.close();
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,
							color: 'success',
							message: 'Categoria creada satisfactoriamente',
							timeout: 2000
						});	
						this.saving = false
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	

					})	
			
			},
			async updateCategory(){
				this.saving = true
				const business_id =  this.currentBusiness.id;
				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`categories/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.categoryForEdit.photo_url = await refPhoto.getDownloadURL()
					this.categoryForEdit.photo_name = fileNamePhoto
					this.hasImage = false;
					this.photo = null;
					this.uploaded = false;
				}

				db.collection('bussiness').doc(business_id).collection('categories').doc(this.categoryForEdit.id)
					.update( this.categoryForEdit )
					.then( docRef => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,color: 'success',timeout: 3000,
							message: 'categoria actualizada satisfactoriamente',
						});	
						this.close();
						this.saving = false
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
					})
			},
			close(){
				const cat = {id: '',name: '',order: 1,photo_name: '',photo_url: '',subtitle: '',visible: true	}
				this.$store.commit('categoryModule/SET_CATEGORY', cat, {root: true})
				this.$refs.imager['imagePreview'] = null;
				this.categoryForEdit.photo_url = '';
				this.photo = null;
				this.openDialog = false
			},
			uploadPhoto(event,type) {
				const extensionFile = event.target.files[0].type;
				if(extensionFile === 'image/jpeg' || extensionFile === 'image/png'){
					this.file = event.target.files[0]
					this.error = null
				}else{
					this.error = 'Archivo no válido'
					this.file = null
					return 
				}
				const reader = new FileReader();
				reader.readAsDataURL(this.file);
				reader.onload = (e) => {
					this.photo = e.target.result
					this.uploaded = true;
				}
					
			}, //.uploadPhoto



		},		
		computed: {
			...mapState(['alert','loaded']),
			...mapState('authModule',['user','logonUser']),
			...mapState('categoryModule',['dialogList','showItems','category']),
			...mapState('businessModule',['business']),	
			...mapGetters('userModule',['role','currentUser']),
			...mapGetters('businessModule',['currentBusiness']),
			...mapGetters('categoryModule',['categoryForEdit',,'categoriesDialog','categoryLoaded','dialogsList','categoriesList','categoryDialogEditMode']),
			photoExist(){
				return (this.categoryForEdit.photo_url != '' && this.categoryForEdit.photo_url !== null )
			},
			showImage(){
				return !this.hasImage && (this.categoryForEdit.photo_url != '')
			},
		},
		
	}
</script>

<style>
.botones_list {
	margin: 0px 10px 10px 0px;
    font-size: xx-large;
}
	
#fileInput {
		display: none;
	}
</style>

